module.exports = __webpack_public_path__ + "img/code-square-02.2268049e.svg";